import { Directive } from "./Directive.js";
import type { GameState } from "../../../royalur/engine/state/GameState.js";
import { PlayerType } from "../../../royalur/model/PlayerType.js";
import type { BoardDirective } from "./board/BoardDirective.js";
import type { DiceDirective } from "./dice/DiceDirective.js";
import type { PlayerStateDirective } from "./playerstate/PlayerStateDirective.js";


/**
 * A directive for rendering the game.
 */
export class GameDirective extends Directive {
    readonly state: GameState;
    readonly activePlayer: PlayerType;

    readonly boardDirectives: BoardDirective[];
    readonly diceDirectives: DiceDirective[];
    readonly playerStateDirectives: PlayerStateDirective[];

    constructor(
        directiveID: number,
        state: GameState,
        boardDirectives: BoardDirective[],
        diceDirectives: DiceDirective[],
        playerStateDirectives: PlayerStateDirective[],
    ) {
        super(directiveID);
        if (boardDirectives.length === 0)
            throw new Error("No board directives were supplied");
        if (diceDirectives.length === 0)
            throw new Error("No dice directives were supplied");
        if (playerStateDirectives.length === 0)
            throw new Error("No player state directives were supplied");

        this.state = state;
        this.activePlayer = state.getSubject() ?? PlayerType.LIGHT;
        this.boardDirectives = boardDirectives;
        this.diceDirectives = diceDirectives;
        this.playerStateDirectives = playerStateDirectives;
    }

    getAllDirectives(): Directive[] {
        return [
            ...this.boardDirectives,
            ...this.diceDirectives,
            ...this.playerStateDirectives,
        ];
    }

    isLimboDirective(): boolean {
        for (const directive of this.getAllDirectives()) {
            if (!directive.isLimboDirective())
                return false;
        }
        return true;
    }
}
